import { render, staticRenderFns } from "./DossiersWithPIBySexe.vue?vue&type=template&id=1900388f&"
import script from "./DossiersWithPIBySexe.vue?vue&type=script&lang=ts&"
export * from "./DossiersWithPIBySexe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports